import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { popupOpenService } from './popupOpenService';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';
import Modal from "./Modal";
import {MODAL_SMALL_SIZE} from "../components/helper";

const RestoreModalContent = ({ restoreItem, handleClose, itemTitle, tab }) => {
    const { i18n } = useTranslation();
    return (
        <>
            <h2 className="modal__title modal__title_align block__title-h3 block__title-h3">{i18n.t(`app.page.product.restore.modal.${tab}.title`)}</h2>
            <p className="block__content modal__text modal__text_align">{i18n.t(`app.page.product.restore.modal.${tab}.content`)} {itemTitle}?</p>
            <div className="modal__button-group">
                <Button variant="outline" onClick={() => handleClose(null)}>
                    {i18n.t('app.page.product.modal.cancel')}
                </Button>
                <Button onClick={restoreItem}>
                    {i18n.t('app.page.product.modal.restore')}
                </Button>
            </div>
        </>
    )
};

const RestoreItemPopup = ({ notifyItemsList, itemRestoreService }) => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const { tab } = useParams();
    const [itemId, setItemId] = useState('');

    const handleOpenModal = (itemIdValue) => {
        setIsOpen(true);
        setItemId(itemIdValue);
    };    
    
    useEffect(() => {
        popupOpenService.registerPopup(itemRestoreService.getPopupKey(), handleOpenModal);
        return () => popupOpenService.unRegisterPopup(itemRestoreService.getPopupKey(), handleOpenModal);
    },[]);

    const restoreItem = () => {        
        setIsOpen(null);
        itemRestoreService.restoreItem(itemId, notifyItemsList);
    };

    return (
        isOpen ?
            <Modal content={<RestoreModalContent handleClose={setIsOpen} restoreItem={restoreItem} 
                itemTitle={itemRestoreService.getItemTitle(itemId, i18n)} tab={tab}/>}
            handleCloseModal={setIsOpen} size={MODAL_SMALL_SIZE}/>
            :
            null
    );
};

export default RestoreItemPopup;
